<template>
  <div>
    <header-top></header-top>
    <div class="service" :class="{en:language!=='zh'}">
      <div class="banner">
        <div class="bannerBox">
          <p class="title1">{{$t('business.MANA产商服务')}}</p>
          <p class="title2">{{$t('business.为企业和政府提供基于科技艺术产业链的咨询、资源整合以及整体解决方案服务；输出和定制具有“投入-产出”闭环逻辑和IP属性的内容型产品。')}}</p>
          <a class="title3" href="http://manabang.mikecrm.com/ShhECqa" target="_bank">{{$t('business.服务接洽')}}</a>
        </div>
      </div>
      <div class="serviceBox">
        <div class="serviceNav">
          <p class="title">{{$t('business.四大服务')}}</p>
          <div class="clearfix">
            <div class="serviceTitle service1">
              <p class="title1">{{$t('business.咨询顾问')}}</p>
              <p class="title2">{{$t('business.科技艺术生产效率赋能')}}</p>
              <p class="title2">{{$t('business.科技艺术场景与品牌赋能')}}</p>
              <p class="title2">{{$t('business.科技艺术产品与运营赋能')}}</p>
              <p class="title2">{{$t('business.科技艺术战略与模型')}}</p>
            </div>
            <div class="serviceTitle service2">
              <p class="title1">{{$t('business.资源整合')}}</p>
              <p class="title2">{{$t('business.内容与创作者资源整合')}}</p>
              <p class="title2">{{$t('business.科技艺术产业链整合')}}</p>
              <p class="title2">{{$t('business.科技艺术教育培训资源整合')}}</p>
              <p class="title2">{{$t('business.项目与资本资源整合')}}</p>
            </div>
            <div class="serviceTitle service3">
              <p class="title1">{{$t('business.解决方案')}}</p>
              <p class="title2">{{$t('business.科技艺术新策略、新产品的规划与实施')}}</p>
              <p class="title2">{{$t('business.咨询-方案-资源-落地-运营的全案整合服务')}}</p>
              <p class="title2">{{$t('business.长期战略型科技艺术项目的落地')}}</p>
              <p class="title2">{{$t('business.构建科技艺术产品体系和运营系统')}}</p>
            </div>
            <div
              class="serviceTitle service4"
              :class="{'activeOpen': isShow}"
              @mouseenter="isShow=true"
              @mouseleave="isShow=false"
            >
              <p class="title1">{{$t('business.产品输出')}}</p>
              <p class="title2" :class="{'active': isShow}">{{$t('business.服务产品')}}</p>
              <div class="showTitle" v-if="isShow">
                <p class="showTitle1">
                  MANA Screening
                  <span>{{$t('business.基于屏幕的商业与公共空间数字艺术周期性策展')}}</span>
                </p>
                <p class="showTitle1">
                  MANA ShowCase
                  <span>{{$t('business.数字艺术内容赋能展览展示')}}</span>
                </p>
                <p class="showTitle1">
                  MANA X-Lab
                  <span>{{$t('business.科技艺术未来生活场景实验室')}}</span>
                </p>
              </div>
              <p class="title2" :class="{'active': isShow}">{{$t('business.场馆产品')}}</p>
              <div class="showTitle" v-if="isShow">
                <p class="showTitle1">
                  MANA Land
                  <span>{{$t('business.沉浸式新媒体艺术主题系列乐园')}}</span>
                </p>
                <p class="showTitle1">
                  MANA Museum
                  <span>{{$t('business.科技艺术主题系列美术馆、博物馆')}}</span>
                </p>
              </div>
              <p class="title2" :class="{'active': isShow}">{{$t('business.城市产品')}}</p>
              <div class="showTitle" v-if="isShow">
                <p class="showTitle1">
                  MANA Center
                  <span>{{$t('business.科技艺术产业、文旅及商业园区（或综合体）')}}</span>
                </p>
                <p class="showTitle1">
                  MANA Block
                  <span>{{$t('business.科技艺术产业、商业及生活街区')}}</span>
                </p>
                <p class="showTitle1">
                  MANA Festival
                  <span>{{$t('business.城市科技艺术节庆活动系列产品')}}</span>
                </p>
              </div>
              <i v-if="!isShow"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="market_text">
        <p class="text_title">{{$t('business.市场&应用')}}</p>
        <div class="marketBox">
          <div class="box clearfix">
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_1@2x.png" alt />
              <p class="title">{{$t('business.城市活动')}}</p>
              <p class="title1">{{$t('business.艺术节')}}</p>
              <p class="title1">{{$t('business.竞赛')}}</p>
              <p class="title1">{{$t('business.活动周')}}</p>
              <p class="title1">{{$t('business.社区服务')}}</p>
              <p class="title1">{{$t('business.乡镇活动')}}</p>
            </div>
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_2@2x.png" alt />
              <p class="title">{{$t('business.城市空间')}}</p>
              <p class="title1">{{$t('business.交通枢纽')}}</p>
              <p class="title1">{{$t('business.广场公园')}}</p>
              <p class="title1">{{$t('business.街景河景')}}</p>
              <p class="title1">{{$t('business.商业空间')}}</p>
            </div>
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_3@2x.png" alt />
              <p class="title">{{$t('business.文化复兴')}}</p>
              <p class="title1">{{$t('business.文保数字化')}}</p>
              <p class="title1">{{$t('business.IP研发')}}</p>
              <p class="title1">{{$t('business.节庆活动')}}</p>
              <p class="title1">{{$t('business.文化场馆')}}</p>
            </div>
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_4@2x.png" alt />
              <p class="title">{{$t('business.文旅夜游')}}</p>
              <p class="title1">{{$t('business.景区赋能')}}</p>
              <p class="title1">{{$t('business.IP研发')}}</p>
              <p class="title1">{{$t('business.内容整合')}}</p>
            </div>
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_5@2x.png" alt />
              <p class="title">5G+/AR/XR</p>
              <p class="title1">{{$t('business.内容与场景开发')}}</p>
              <p class="title1">{{$t('business.运作系统整合')}}</p>
              <p class="title1">{{$t('business.样板场景打造')}}</p>
            </div>
            <div class="market">
              <img src="https://image.manamana.net/web_industrial_market_icon_6@2x.png" alt />
              <p class="title">{{$t('business.园区/街区/产城')}}</p>
              <p class="title1">{{$t('business.新基建内容场景')}}</p>
              <p class="title1">{{$t('business.智慧城市')}}</p>
              <p class="title1">{{$t('business.城市更新')}}</p>
              <p class="title1">{{$t('business.新型产业园区')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="about">
        <div class="aboutBox">
          <p class="title1">{{$t('business.关于MANA')}}</p>
          <p class="title2">{{$t('business.MANA是全球科技艺术产业的整合服务平台。')}}</p>
          <p class="title3">{{$t('business.基于全球的内容与创作者分享平台，聚集科技艺术专业及产业资源，提供产业链整合及增效服务。')}}</p>
          <p class="title4">{{$t('business.为文创娱乐、商业文旅、会展节庆及城市乡村运营，研发下一代际科技艺术场景与服务产品。')}}</p>
          <a class="bank" href="http://manabang.mikecrm.com/ShhECqa" target="_bank">{{$t('business.服务接洽')}}</a>
          <p class="title5">{{$t('business.联系邮箱')}}：<a href="mailto:business@manamana.net">business@manamana.net</a></p>
          <p class="title5">{{$t('business.服务热线')}}：021-52998050</p>
        </div>
      </div>
    </div>
    <footer-down class="searchFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";

export default {
  name: "service",
  metaInfo() {
    return {
      title: this.$t("business.产商服务") + " | MANA",
    };
  },
  components: {
    HeaderTop,
    FooterDown,
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {
    this.buriedPoint(20,0)
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  watch: {
    $route(to, from) {},
  },
};
</script>

<style lang="stylus" scoped>
.searchFooter {
  position: relative !important;
}

.service {
  width: 100%;

  .banner {
    width: 100%;
    height: 480px;
    background: url('https://image.manamana.net/1599792022830_kWWvRDJR');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    .bannerBox {
      padding-top: 123px;

      .title1 {
        font-size: 40px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
      }

      .title2 {
        width: 584px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        text-align: center;
        margin: 40px auto 56px;
      }

      .title3 {
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #2658C3;
        border-radius: 2px;
        font-size: 18px;
        font-weight: 600;
        color: #FFFFFF;
        margin: 0 auto;
        cursor: pointer;
        display: block;
      }
    }
  }

  .serviceBox {
    width: 100%;
    padding-top: 70px;
    background: #fff;

    .serviceNav {
      width: 1110px;
      margin: 0 auto;
      font-size: 0;

      .title {
        font-size: 24px;
        font-weight: 400;
        color: #0A0A0A;
        margin-bottom: 60px;
        text-align: center;
      }

      .serviceTitle {
        float: left;
        width: 540px;
        height: 230px;
        padding: 28px 40px 0 40px;
        box-sizing: border-box;
        margin: 0 30px 30px 0;

        .title1 {
          font-size: 26px;
          font-weight: 600;
          color: #FFFFFF;
          margin-bottom: 24px;
        }

        .title2 {
          font-size: 15px;
          font-weight: 400;
          color: #FFFFFF;
          margin-bottom: 8px;
        }

        .active {
          color: #36C4ED;
          font-weight: 600;
        }

        .showTitle {
          margin-bottom: 24px;

          .showTitle1 {
            font-size: 14px;
            font-weight: 800;
            color: #FFFFFF;
            margin-bottom: 6px;
            line-height: 21px;

            span {
              font-weight: 400;
              margin-left: 8px;
            }
          }
        }
      }

      .service1 {
        background: url('https://image.manamana.net/web_industrial_service_1_bg@2x.png') no-repeat;
        background-size: 100% 100%;
      }

      .service2 {
        margin-right: 0;
        background: url('https://image.manamana.net/web_industrial_service_2_bg@2x.png') no-repeat;
        background-size: 100% 100%;
      }

      .service3 {
        background: url('https://image.manamana.net/web_industrial_service_3_bg@2x.png') no-repeat;
        background-size: 100% 100%;
      }

      .service4 {
        margin-right: 0;
        background: url('https://image.manamana.net/web_industrial_service_4_bg@2x.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        transition: all 0.35s;

        i {
          background: url('https://image.manamana.net/web_industrial_service_4_view_more_btn@2x.png') no-repeat;
          width: 30px;
          height: 30px;
          background-size: 100% 100%;
          position: absolute;
          bottom: 8px;
          left: 255px;
          cursor: pointer;
        }
      }

      .activeOpen {
        height: 455px;
        background: url('https://image.manamana.net/web_industrial_service_4_bg_opened@2x.png') no-repeat;
        background-size: 100% 100%;
        transition: all 0.35s;
      }
    }
  }

  .market_text {
    background: #fff;
    padding-top: 157px;

    .text_title {
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 67px;
    }

    .marketBox {
      width: 100%;
      height: 520px;
      background: url('https://image.manamana.net/web_industrial_market_bg@2x.png') no-repeat;
      background-size: 100% 100%;

      .box {
        width: 1110px;
        height: 380px;
        margin: 0 auto;

        .market {
          float: left;
          width: 160px;
          height: 380px;
          background: #FFFFFF;
          box-shadow: 0px 2px 10px 0px rgba(102, 112, 144, 0.1);
          margin-right: 30px;
          text-align: center;
          padding-top: 27px;
          box-sizing: border-box;

          &:nth-child(6) {
            margin-right: 0;
          }

          img {
            width: 44px;
            height: 44px;
          }

          .title {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            margin: 27px 0 33px 0;
            word-break: break-word;
          }

          .title1 {
            font-size: 16px;
            font-weight: 300;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
        }
      }
    }
  }

  .about {
    background: #fff;
    height: 528px;
    width: 100%;
    padding-top: 140px;

    .aboutBox {
      width: 920px;
      margin: 0 auto;
      text-align: center;

      .title1 {
        font-size: 24px;
        font-weight: 400;
        color: #0A0A0A;
      }

      .title2, .title3, .title4 {
        font-size: 18px;
        font-weight: 400;
        color: #666666;
      }

      .title2 {
        margin-top: 50px;
      }

      .title3 {
        margin: 20px 0;
      }

      .title4 {
        margin-bottom: 90px;
      }

      .bank {
        width: 280px;
        height: 60px;
        background: #2658C3;
        box-shadow: 0px 1px 2px 0px rgba(32, 5, 97, 0.08), 0px 2px 4px 0px rgba(32, 5, 97, 0.1);
        border-radius: 2px;
        line-height: 60px;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        color: #FFFFFF;
        margin: 0 auto 40px;
        cursor: pointer;
        display: block;
      }

      .title5 {
        font-size: 18px;
        font-weight: 400;
        color: #333333;

        a {
          color: #2658C3;
        }
      }
    }
  }

  &.en {
    .banner .bannerBox {
      padding-top: 70px;
    }

    .banner .bannerBox .title1 {
      font-size: 44px;
     }

     .serviceBox .serviceNav .serviceTitle {
      padding: 20px 85px 0 30px;

      &.activeOpen {
        padding-right: 60px;
      }
     }

     .serviceBox .serviceNav .serviceTitle .title1 {
      margin-bottom: 10px;
     }

     .serviceBox .serviceNav .serviceTitle .title2 {
      font-size: 13px;
     }

     .serviceBox .serviceNav .serviceTitle .showTitle {
      margin-bottom: 20px;
     }
    .market_text .marketBox .box .market {
      width: 170px;
      margin-right: 15px;
      padding: 27px 8px 0;

      .title {
        height: 42px;
        font-size: 15px;
      }

      .title1 {
        font-size: 13px;
      }
    }

    .about .aboutBox .title2 {
      font-size: 16px;
      line-height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/service.vue